<template>
  <li v-cloak v-if="notificationCnt>0 && secret == '0'">
    <el-popover
        @hide="notificationsHide"
        popper-class="notifications-popover"
        placement="bottom"
        visible-arrow="true"
        width="350"
        trigger="click">
      <div class="header">
        <a class="back" @click="backToList" v-if="notification>-1"><i class="el-icon-arrow-left"></i></a>
        <h5 v-text="res.shop_latest_notifications"></h5>
        <a class="close top" href="#" @click="close($event)">
          <i class="el-icon-circle-close"></i>
        </a>
      </div>
      <div class="content">
        <div class="list" v-bind:style="{ display: notification == -1 ? 'block' : 'none' }">
          <ul>
            <li v-for="(data, index) in notifications" v-text="data.heading" @click="notificationDetail(index)"></li>
          </ul>
        </div>
        <div class="details" v-bind:style="{ display: notification>-1 ? 'block' : 'none' }" v-html="notifications[notification] ? notifications[notification].details : ''"></div>
      </div>
      <a slot="reference" href="#"><span class="semibold" v-text="res.shop_notifications"></span>
        <span class="notification-cnt notifications" v-html="notificationCnt"></span>
      </a>
    </el-popover>
  </li>
</template>
<script>
import Vue from 'vue'
import axios from "axios";
export const bus = new Vue();

export default {

  data: function() {
    return {
      view_mode : null,
      notifications : [],
      notification : -1,
      res : $r
    }
  },
  computed: {
    notificationCnt : function (){
      return this.notifications.length;
    }
  },

  methods : {

    getViewMode(){
      var classes = document.querySelector('body').className.split(' ');
      return classes[0]
    },

    close(e_){
      e_.preventDefault();
      this.$children[0].doClose();
    },
    notificationDetail(idx_){
      this.notification = idx_;
    },

    notificationsHide(){
      this.notification = -1;
    },

    backToList(){
      this.notification = -1;
    },

    getNotifications(){
      var $this = this;
      // get Notifications
      axios.get('/' + window.lang + '/shop/notifications')
          .then(response => {
            $this.notifications = response.data;
            bus.$emit('getNotifications', $this.notifications);
          });
    }
  },

  props: ['secret'],

  mounted(){
    var $this = this;

    setTimeout(function (){
      $this.view_mode = $this.getViewMode();
    }, 500);

    this.getNotifications();

    document.addEventListener("click", function(event) {
      if (event.target.closest(".semibold")) return;
      if ($this.$children.length > 0)
        $this.$children[0].doClose();
    });

    window.addEventListener('resize',  function (){
      $this.view_mode = $this.getViewMode();
    });

    const body = document.body;
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;
    var header = document.querySelector('.shop-header-2');
    var sticky = header.offsetTop;

    window.addEventListener('scroll',function(e){

      var offset = ($this.view_mode == 'desktop-view' ? 0 : 50);
      if (window.pageYOffset + offset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }

      const currentScroll = window.pageYOffset;
      if (currentScroll <= 0) {
        body.classList.remove(scrollUp);
        return;
      }

      if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && window.pageYOffset > sticky)
      {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
      }
      else if (currentScroll < lastScroll && body.classList.contains(scrollDown))
      {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }
      lastScroll = currentScroll;
    })
  }
}
</script>